import ImageIcon from '@atlaskit/icon/core/image';
import * as React from 'react';

export function SvgImage1() {
  return <ImageIcon label="" testId="ads-refreshed-icon" />;
}
